import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "./cn";
const alertVariants = cva("relative grid w-full grid-cols-[0_1fr] items-start gap-y-1 rounded-lg border p-4 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5", {
    variants: {
        variant: {
            default: "bg-card text-card-foreground",
            destructive: "border-destructive/30 bg-card text-destructive [&>svg]:text-current",
            warning: "border-amber-200 bg-amber-50 text-amber-900 [&>svg]:text-amber-600",
            success: "border-emerald-200 bg-emerald-50 text-emerald-900 [&>svg]:text-emerald-600",
        },
    },
    defaultVariants: { variant: "default" },
});
export function Alert({ className, variant, ...props }) {
    return (_jsx("div", { role: "alert", "data-slot": "alert", className: cn(alertVariants({ variant }), className), ...props }));
}
export function AlertTitle({ className, ...props }) {
    return (_jsx("h5", { "data-slot": "alert-title", className: cn("col-start-2 font-medium leading-none", className), ...props }));
}
export function AlertDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-description", className: cn("col-start-2 text-sm text-current/80 [&_p]:leading-relaxed", className), ...props }));
}
//# sourceMappingURL=alert.js.map